import { NegotiationOption, NegotiationType, OutDebt } from '../generated/graphql';
import { useGetPaymentDates } from './useGetPaymentDates';

export const useGetNegotiationExpiredActionInfo = (
  { outDebt, negOptions }: { outDebt: OutDebt, negOptions: NegotiationOption[] },
) => {
  const { negotiation, bank } = outDebt;
  const { maxPaymentDate, minPaymentDate } = useGetPaymentDates(
    bank,
    negotiation?.negotiationOption,
  );

  const enoughDays = maxPaymentDate.diff(minPaymentDate, 'days') > 0;

  const sameOption = negOptions
    .find((opt) => {
      const sameType = opt.type === negotiation?.type;
      const sameAlt = opt.alternatives.some((alt) => alt.term === negotiation?.alternative.term);
      return sameType && sameAlt;
    });
  const otherOptions = negOptions
    .filter((op) => op !== sameOption && op.type !== NegotiationType.NoOptions);

  const sameAvailable = !!sameOption && enoughDays;
  const otherAvailable = !sameAvailable && otherOptions.length > 0;
  const noneAvailable = !sameAvailable && !otherAvailable;

  return { sameAvailable, otherAvailable, noneAvailable, minPaymentDate, maxPaymentDate };
};
